import { createStyles, makeStyles, Theme } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import EditIcon from "@material-ui/icons/Edit";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import { FONTS } from "../../constants";
import { addChartProps, addedChartsType } from "../../state";
import { trimString } from "../Common/helpers";
import { chartInputsType } from "./Charts/DataTable";

export const MAX_TITLE_LEN = 200;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    groupDescTitle: {
      fontSize: "20px",
      fontFamily: FONTS,
      margin: "20px",
      fontWeight: "bold",
      color: "rgba(0,0,0,0.7)",
      textOverflow: "ellipsis",
      overflow: "hidden",
      width: "70%",
      whiteSpace: "nowrap",
    },
    container: {
      flex: 1,
      overflow: "auto",
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
    },
    iconTitleContainer: {
      display: "flex",
      flexDirection: "row",
    },
    iconsContainer: {
      display: "flex",
      flexDirection: "row",
      marginTop: "20px",
      marginBottom: "20px",
      color: "rgba(0,0,0,0.7)",
      overflow: "hidden",
    },
    iconContainer: {
      marginLeft: "10px",
      cursor: "pointer",
      transition: "0s",
      "&:hover": { transform: "scale(1.2)" },
    },
  })
);

export function getDefaultChartTitle(chartProps: addChartProps) {
  let defaultTitle = "";
  if (chartProps.var1 === chartProps.var2) {
    defaultTitle = trimString(
      `${chartProps.agg_type} of ${chartProps.value} by ${chartProps.var2}`,
      MAX_TITLE_LEN
    );
  } else {
    defaultTitle = trimString(
      `${chartProps.agg_type} of ${chartProps.value}, ${chartProps.var1} vs ${chartProps.var2}`,
      MAX_TITLE_LEN
    );
  }
  return defaultTitle;
}

export function ChartHeader({
  chartProps,
  chartAggData,
  state,
  isPreview,
}: chartInputsType) {
  const classes = useStyles();
  if (isPreview && chartProps.title === "") {
    return <div></div>;
  }

  function handleDelete() {
    let current = [...state.addedCharts];
    current.splice(chartProps.index, 1);
    for (let i = 0; i < current.length; i++) {
      current[i].chartProps.index = i;
    }
    state.setAddedCharts(current);
  }

  function handleUpClick() {
    if (chartProps.index === 0) {
      return;
    }
    let current = [...state.addedCharts];
    let reOrdered: addedChartsType[] = [];
    const newIndex = chartProps.index - 1;
    const oldIndex = chartProps.index;
    for (let i = 0; i < current.length; i++) {
      if (i === newIndex) {
        reOrdered.push(current[oldIndex]);
      }
      if (i === oldIndex) {
        continue;
      }
      reOrdered.push(current[i]);
    }
    for (let i = 0; i < reOrdered.length; i++) {
      reOrdered[i].chartProps.index = i;
    }

    state.setAddedCharts(reOrdered);
  }
  function handleDownClick() {
    if (chartProps.index === state.addedCharts.length - 1) {
      return;
    }
    let current = [...state.addedCharts];
    let reOrdered: addedChartsType[] = [];
    const newIndex = chartProps.index + 1;
    const oldIndex = chartProps.index;
    for (let i = 0; i < current.length; i++) {
      if (i === newIndex) {
        reOrdered.push({ ...current[oldIndex] });
      } else if (i === oldIndex) {
        reOrdered.push({ ...current[newIndex] });
      } else {
        reOrdered.push({ ...current[i] });
      }
    }
    for (let i = 0; i < reOrdered.length; i++) {
      reOrdered[i].chartProps.index = i;
    }

    state.setAddedCharts(reOrdered);
  }

  function handleEditClick() {
    state.setAddChartInputs(chartProps);
    state.setChartAggData(chartAggData);
    state.setIsAddPopupEditMode(true);
    state.setIsAddChartOpen(true);
  }
  const ai = chartProps;
  const anyUndefined =
    ai.agg_type === undefined ||
    ai.value === undefined ||
    ai.var1 === undefined ||
    ai.var2 === undefined;

  let defaultTitle = "";
  if (!anyUndefined) {
    defaultTitle = getDefaultChartTitle(ai);
  }

  return (
    <div className={classes.container}>
      <div className={classes.groupDescTitle}>
        {chartProps.title === undefined ? defaultTitle : chartProps.title}
      </div>
      {!isPreview ? (
        <div className={classes.iconsContainer}>
          <div className={classes.iconContainer} onClick={handleEditClick}>
            <EditIcon></EditIcon>
          </div>
          <div className={classes.iconContainer} onClick={handleUpClick}>
            <KeyboardArrowUpIcon></KeyboardArrowUpIcon>
          </div>
          <div className={classes.iconContainer} onClick={handleDownClick}>
            <KeyboardArrowDownIcon></KeyboardArrowDownIcon>
          </div>
          <div className={classes.iconContainer} onClick={handleDelete}>
            <CloseIcon></CloseIcon>
          </div>
        </div>
      ) : (
        <div></div>
      )}
      {/* <div className={classes.lineContainer}>
        {chartProps.title === "" ? <div></div> : <Line></Line>}
      </div> */}
    </div>
  );
}
